<template>
  <!-- Левая панель десктопа, когда карточка объекта не открыта: экран поиска
       без отдельного «покоя» - поле, под ним «Недавние» и «Маршруты рядом»
       (при вводе - подсказки). Фокус только ставит курсор; «Отмена» - когда
       в поле текст или курсор. Выбор объекта - карточка в этой же панели
       (App.vue: PointCard / RouteDetailsPanel вместо LeftPanel), «Назад» в ней -
       обратно сюда с тем же текстом (searchSession). -->
  <div class="flex flex-col h-full overflow-hidden">
    <h1 class="sr-only">{{ $t('leftPanel.brand') }}</h1>
    <SearchPanel
      variant="desktop"
      class="flex-1 min-h-0"
      @open-route="(id) => emit('open-route', id)"
      @open-point="(id) => emit('open-point', id)"
    />
  </div>
</template>

<script setup lang="ts">
import SearchPanel from "./search/SearchPanel.vue";

const emit = defineEmits<{
  (e: "open-route", routeId: number): void;
  (e: "open-point", id: string): void;
}>();
</script>
